import { ConstructionTrade, SimpleDuration } from "__generated__/graphql";
import { z } from "zod";

export const organizationInfoSchema = z.object({
  organization: z.string().min(1, "Organization Name is required"),
  roleInOrganization: z.string().min(1, "Role in organization is required"),
  industry: z.string().optional(),
});

export const contactInfoSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.string().email("Please enter a valid email address"),
  phone: z.string().min(10, "Please enter a valid phone number"),
});

export const constructionDetailsSchema = z.object({
  projectLocation: z.string().min(1, "Project location is required"),
  intendedDuration: z.nativeEnum(SimpleDuration),
  trades: z.array(
    z.nativeEnum(ConstructionTrade)
  ).min(1, "Select at least one trade"),
  otherTrade: z.string().optional(),
  estimatedArtisanCount: z
    .number({ invalid_type_error: "Please enter a valid number" })
    .min(1, "At least 1 artisan required"),
  willProvideMaterials: z.boolean(),
  includeMaterialsInCost: z.boolean().optional(),
}).refine((data) => {
  if (!data.willProvideMaterials) {
    return typeof data.includeMaterialsInCost === "boolean";
  }
  return true;
}, {
  message: "Please indicate if materials should be included in cost",
  path: ["includeMaterialsInCost"],
});

export type OrganizationInfoFormData = z.infer<typeof organizationInfoSchema>;
export type ConstructionContactInfoFormData = z.infer<typeof contactInfoSchema>;
export type ConstructionDetailsFormData = z.infer<typeof constructionDetailsSchema>;


